import { Text } from '@loadsmart/miranda-react'

export type RatePerMileProps = {
  ratePerMile: string
}

function RatePerMile({ ratePerMile }: RatePerMileProps) {
  return <Text variant="body-md">{ratePerMile} per mile</Text>
}

export { RatePerMile }
